import { render } from "./NameEntry.vue?vue&type=template&id=70be19c2&scoped=true"
import script from "./NameEntry.vue?vue&type=script&lang=js"
export * from "./NameEntry.vue?vue&type=script&lang=js"

import "./NameEntry.vue?vue&type=style&index=0&id=70be19c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70be19c2"]])

export default __exports__